export const FETCH_PLATFORM_ALERTS = 'FETCH_PLATFORM_ALERTS';
export const PLATFORM_ALERTS_SUCCESS = 'PLATFORM_ALERTS_SUCCESS';
export const PLATFORM_ALERTS_ERROR = 'PLATFORM_ALERTS_ERROR';
